import { render, staticRenderFns } from "./BaseDescription.vue?vue&type=template&id=ccceee60&scoped=true"
import script from "./BaseDescription.vue?vue&type=script&lang=js"
export * from "./BaseDescription.vue?vue&type=script&lang=js"
import style0 from "./BaseDescription.vue?vue&type=style&index=0&id=ccceee60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccceee60",
  null
  
)

export default component.exports